import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import gitlabFeatureFlagsReducer from './gitlabFeatureFlagsSlice';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		gitlabFeatureFlags: gitlabFeatureFlagsReducer
	}
});
